/**
 * checkOutWarnings — pure helper that reads the server's `warning[]` list from
 * a check-out-start response.
 *
 * The list sits on the response envelope (a sibling of `data`), which
 * `unwrap()` discards. It is present on a success, on `success: false`, and on
 * the 4xx envelope built by GlobalExceptionListener.
 *
 * @module checkOutWarnings
 */

/**
 * @param {*} response axios-style `{ data: envelope }` (a thrown error's
 *   `err.response` works too) or the bare envelope.
 * @returns {string[]} trimmed, non-empty, deduped warning lines
 */
export function extractEnvelopeWarnings(response) {
	if (!response || typeof response !== 'object') return [];
	const envelope = 'data' in response ? response.data : response;
	const list = envelope && typeof envelope === 'object' ? envelope.warning : null;
	if (!Array.isArray(list)) return [];
	return Array.from(
		new Set(list.filter(w => typeof w === 'string' && w.trim()).map(w => w.trim()))
	);
}
